import React, { useState } from "react";
import axios from "axios";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const login = async (e) => {
    e.preventDefault();

    const API_URL = import.meta.env?.VITE_API_URL || process.env?.REACT_APP_API_URL || "http://localhost:5000";
    try {
     const res = await axios.post(`${API_URL}/api/login`, form);
      localStorage.setItem("token", res.data.token);
      window.location.href = "/admin";
    } catch {
      alert("Login failed");
    }
  };

  return (
    <div className="p-10 max-w-sm mx-auto">
      <h1 className="text-2xl font-bold mb-6">Admin Login</h1>

      <form onSubmit={login} className="flex flex-col gap-4">
        <input name="email" placeholder="Email" onChange={handleChange} className="border p-2" />
        <input name="password" type="password" placeholder="Password" onChange={handleChange} className="border p-2" />

        <button className="bg-pink-500 text-white py-2 rounded">
          Login
        </button>
      </form>
    </div>
  );
}